import { useState } from 'react';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';
import { Box } from '@material-ui/core';

export default () => {
  const [searchParam, setSearchParam] = useState({
    consumeEndTime: null,
    consumeStartTime: null,
    sendStartTime: null,
    sendEndTime: null,
    couponId: '',
    mobile: '',
    cardCode: '',
    pageSize: '10',
    pageNum: 1,
  });

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_coupon_center_coupon_verification_details',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      {/* <TitleML title='优惠券核销列表' fontSize="20px" /> */}
      {/* <div style={{ color: '#000', fontSize: '22px', marginBottom: '14px' }}>
        优惠券核销
      </div> */}
      <SearchGroup setSearchParam={setSearchParam} />
      <ResultList searchParam={searchParam} setSearchParam={setSearchParam} />
    </Box>
  );
};
